export const ArrowIconPrimary = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`ArrowIconPrimary`}
  >
    <path
      className="bg"
      d="M0 3.2C0 2.0799 0 1.51984 0.217987 1.09202C0.409734 0.715695 0.715695 0.409734 1.09202 0.217987C1.51984 0 2.0799 0 3.2 0H20.8C21.9201 0 22.4802 0 22.908 0.217987C23.2843 0.409734 23.5903 0.715695 23.782 1.09202C24 1.51984 24 2.0799 24 3.2V20.8C24 21.9201 24 22.4802 23.782 22.908C23.5903 23.2843 23.2843 23.5903 22.908 23.782C22.4802 24 21.9201 24 20.8 24H3.2C2.0799 24 1.51984 24 1.09202 23.782C0.715695 23.5903 0.409734 23.2843 0.217987 22.908C0 22.4802 0 21.9201 0 20.8V3.2Z"
      fill=""
      fillOpacity="1"
    />
    <path
      className="arrow"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1537 7.64652L12.8002 7.29297L12.0931 8.00008L12.4466 8.35363L15.5925 11.4995H7.2002H6.7002V12.4995H7.2002H15.5937L12.4466 15.6465L12.0931 16.0001L12.8002 16.7072L13.1537 16.3536L17.1537 12.3536C17.349 12.1584 17.349 11.8418 17.1537 11.6465L13.1537 7.64652Z"
      fill="white"
    />
  </svg>
);

export const ArrowIconTextlink = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`ArrowIconTextlink`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.15375 3.64652L8.8002 3.29297L8.09309 4.00008L8.44664 4.35363L11.5925 7.49949H3.2002H2.7002V8.49949H3.2002H11.5937L8.44664 11.6465L8.09309 12.0001L8.8002 12.7072L9.15375 12.3536L13.1537 8.35363C13.349 8.15837 13.349 7.84178 13.1537 7.64652L9.15375 3.64652Z"
      fill="currentColor"
      className="arrow"
    />
  </svg>
);

export const LoadingIconPrimary = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1040_834)">
      <path
        opacity="0.2"
        d="M4.41992 1.62C5.61992 0.9 7.05992 0.5 8.49992 0.5V1.3C7.21992 1.3 5.93992 1.62 4.89992 2.26L4.41992 1.62Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M1.54004 4.50012C2.26004 3.30012 3.22004 2.34012 4.42004 1.62012L4.90004 2.26012C3.78004 2.90012 2.90004 3.78012 2.26004 4.90012L1.54004 4.50012Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M2.26 4.9C1.62 5.94 1.3 7.22 1.3 8.5H0.5C0.5 7.06 0.9 5.7 1.54 4.5L2.26 4.9Z"
        fill="white"
      />
      <path
        opacity="0.5"
        d="M1.3 8.5C1.3 9.78 1.62 11.06 2.26 12.1L1.62 12.58C0.9 11.38 0.5 9.94 0.5 8.5H1.3Z"
        fill="white"
      />
      <path
        opacity="0.6"
        d="M4.50012 15.4601C3.30012 14.7401 2.34012 13.7801 1.62012 12.5801L2.26012 12.1001C2.90012 13.2201 3.78012 14.1001 4.90012 14.7401L4.50012 15.4601Z"
        fill="white"
      />
      <path
        opacity="0.7"
        d="M8.5 16.4997C7.06 16.4997 5.7 16.0997 4.5 15.4597L4.9 14.7397C5.94 15.3797 7.22 15.6997 8.5 15.6997V16.4997Z"
        fill="white"
      />
      <path
        opacity="0.9"
        d="M12.0996 14.7401C13.2196 14.1001 14.0996 13.2201 14.7396 12.1001L15.4596 12.5001C14.7396 13.7001 13.7796 14.6601 12.5796 15.3801L12.0996 14.7401Z"
        fill="white"
      />
      <path
        opacity="0.8"
        d="M8.5 15.6997C9.78 15.6997 11.06 15.3797 12.1 14.7397L12.58 15.3797C11.38 16.0997 9.94 16.4997 8.5 16.4997V15.6997Z"
        fill="white"
      />
      <path
        opacity="0.1"
        d="M12.1 2.26C11.06 1.62 9.78 1.3 8.5 1.3V0.5C9.94 0.5 11.3 0.9 12.5 1.54L12.1 2.26Z"
        fill="white"
      />
      <path
        d="M15.7002 8.9C15.7002 8.66 15.9402 8.5 16.1002 8.5C16.3402 8.5 16.5002 8.74 16.5002 8.9C16.4202 10.18 16.0202 11.38 15.4602 12.5L14.7402 12.1C15.3002 11.14 15.6202 10.02 15.7002 8.9Z"
        fill="white"
      />
      <path
        opacity="0.05"
        d="M15.2196 4.10004C15.3796 4.26004 15.2996 4.50004 15.1396 4.66004C14.9796 4.82004 14.7396 4.74004 14.5796 4.58004C13.9396 3.62004 13.0596 2.81937 12.0996 2.25937L12.4996 1.54004C13.5396 2.18004 14.4996 3.06004 15.2196 4.10004Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1040_834">
        <rect width="16" height="16" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const LoadingIconSecondary = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_540_12275)">
      <g clipPath="url(#clip1_540_12275)">
        <path
          opacity="0.2"
          d="M4.41992 1.12C5.61992 0.4 7.05992 0 8.49992 0V0.8C7.21992 0.8 5.93992 1.12 4.89992 1.76L4.41992 1.12Z"
          fill="currentColor"
        />
        <path
          opacity="0.3"
          d="M1.54004 4.00012C2.26004 2.80012 3.22004 1.84012 4.42004 1.12012L4.90004 1.76012C3.78004 2.40012 2.90004 3.28004 2.26004 4.40012L1.54004 4.00012Z"
          fill="currentColor"
        />
        <path
          opacity="0.4"
          d="M2.26 4.4C1.62 5.44 1.3 6.72 1.3 8H0.5C0.5 6.56 0.9 5.2 1.54 4L2.26 4.4Z"
          fill="currentColor"
        />
        <path
          opacity="0.5"
          d="M1.3 8C1.3 9.28 1.62 10.56 2.26 11.6L1.62 12.08C0.9 10.88 0.5 9.44 0.5 8H1.3Z"
          fill="currentColor"
        />
        <path
          opacity="0.6"
          d="M4.50012 14.9601C3.30012 14.2401 2.34012 13.2801 1.62012 12.0801L2.26012 11.6001C2.90012 12.7201 3.78012 13.6001 4.90012 14.2401L4.50012 14.9601Z"
          fill="currentColor"
        />
        <path
          opacity="0.7"
          d="M8.5 15.9997C7.06 15.9997 5.7 15.5997 4.5 14.9597L4.9 14.2397C5.94 14.8797 7.22 15.1997 8.5 15.1997V15.9997Z"
          fill="currentColor"
        />
        <path
          opacity="0.9"
          d="M12.0996 14.2401C13.2196 13.6001 14.0996 12.7201 14.7396 11.6001L15.4596 12.0001C14.7396 13.2001 13.7796 14.1601 12.5796 14.8801L12.0996 14.2401Z"
          fill="currentColor"
        />
        <path
          opacity="0.8"
          d="M8.5 15.1997C9.78 15.1997 11.06 14.8797 12.1 14.2397L12.58 14.8797C11.38 15.5997 9.94 15.9997 8.5 15.9997V15.1997Z"
          fill="currentColor"
        />
        <path
          opacity="0.1"
          d="M12.1 1.76C11.06 1.12 9.78 0.8 8.5 0.8V0C9.94 0 11.3 0.4 12.5 1.04L12.1 1.76Z"
          fill="currentColor"
        />
        <path
          d="M15.7002 8.4C15.7002 8.16 15.9402 8 16.1002 8C16.3402 8 16.5002 8.24 16.5002 8.4C16.4202 9.68 16.0202 10.88 15.4602 12L14.7402 11.6C15.3002 10.64 15.6202 9.52 15.7002 8.4Z"
          fill="currentColor"
        />
        <path
          opacity="0.05"
          d="M15.2196 3.60004C15.3796 3.76004 15.2996 4.00004 15.1396 4.16004C14.9796 4.32004 14.7396 4.24004 14.5796 4.08004C13.9396 3.12004 13.0596 2.31937 12.0996 1.75937L12.4996 1.04004C13.5396 1.68004 14.4996 2.56004 15.2196 3.60004Z"
          fill="currentColor"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_540_12275">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
      <clipPath id="clip1_540_12275">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const LoadingIconTertiary = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_540_12275)">
      <g clipPath="url(#clip1_540_12275)">
        <path
          opacity="0.2"
          d="M4.41992 1.12C5.61992 0.4 7.05992 0 8.49992 0V0.8C7.21992 0.8 5.93992 1.12 4.89992 1.76L4.41992 1.12Z"
          fill="#041C1B"
        />
        <path
          opacity="0.3"
          d="M1.54004 4.00012C2.26004 2.80012 3.22004 1.84012 4.42004 1.12012L4.90004 1.76012C3.78004 2.40012 2.90004 3.28004 2.26004 4.40012L1.54004 4.00012Z"
          fill="#041C1B"
        />
        <path
          opacity="0.4"
          d="M2.26 4.4C1.62 5.44 1.3 6.72 1.3 8H0.5C0.5 6.56 0.9 5.2 1.54 4L2.26 4.4Z"
          fill="#041C1B"
        />
        <path
          opacity="0.5"
          d="M1.3 8C1.3 9.28 1.62 10.56 2.26 11.6L1.62 12.08C0.9 10.88 0.5 9.44 0.5 8H1.3Z"
          fill="#041C1B"
        />
        <path
          opacity="0.6"
          d="M4.50012 14.9601C3.30012 14.2401 2.34012 13.2801 1.62012 12.0801L2.26012 11.6001C2.90012 12.7201 3.78012 13.6001 4.90012 14.2401L4.50012 14.9601Z"
          fill="#041C1B"
        />
        <path
          opacity="0.7"
          d="M8.5 15.9997C7.06 15.9997 5.7 15.5997 4.5 14.9597L4.9 14.2397C5.94 14.8797 7.22 15.1997 8.5 15.1997V15.9997Z"
          fill="#041C1B"
        />
        <path
          opacity="0.9"
          d="M12.0996 14.2401C13.2196 13.6001 14.0996 12.7201 14.7396 11.6001L15.4596 12.0001C14.7396 13.2001 13.7796 14.1601 12.5796 14.8801L12.0996 14.2401Z"
          fill="#041C1B"
        />
        <path
          opacity="0.8"
          d="M8.5 15.1997C9.78 15.1997 11.06 14.8797 12.1 14.2397L12.58 14.8797C11.38 15.5997 9.94 15.9997 8.5 15.9997V15.1997Z"
          fill="#041C1B"
        />
        <path
          opacity="0.1"
          d="M12.1 1.76C11.06 1.12 9.78 0.8 8.5 0.8V0C9.94 0 11.3 0.4 12.5 1.04L12.1 1.76Z"
          fill="#041C1B"
        />
        <path
          d="M15.7002 8.4C15.7002 8.16 15.9402 8 16.1002 8C16.3402 8 16.5002 8.24 16.5002 8.4C16.4202 9.68 16.0202 10.88 15.4602 12L14.7402 11.6C15.3002 10.64 15.6202 9.52 15.7002 8.4Z"
          fill="#041C1B"
        />
        <path
          opacity="0.05"
          d="M15.2196 3.60004C15.3796 3.76004 15.2996 4.00004 15.1396 4.16004C14.9796 4.32004 14.7396 4.24004 14.5796 4.08004C13.9396 3.12004 13.0596 2.31937 12.0996 1.75937L12.4996 1.04004C13.5396 1.68004 14.4996 2.56004 15.2196 3.60004Z"
          fill="#041C1B"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_540_12275">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
      <clipPath id="clip1_540_12275">
        <rect width="16" height="16" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const LoadingIconTextlink = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1142_2342)">
      <path
        opacity="0.2"
        d="M3.14453 1.1839C3.98453 0.679902 4.99253 0.399902 6.00053 0.399902V0.959902C5.10453 0.959902 4.20853 1.1839 3.48053 1.6319L3.14453 1.1839Z"
        fill="#007A73"
      />
      <path
        opacity="0.3"
        d="M1.12793 3.20008C1.63193 2.36008 2.30393 1.68808 3.14393 1.18408L3.47993 1.63208C2.69593 2.08008 2.07993 2.69608 1.63193 3.48008L1.12793 3.20008Z"
        fill="#007A73"
      />
      <path
        opacity="0.4"
        d="M1.63239 3.47971C1.18439 4.20771 0.960391 5.10371 0.960391 5.99971H0.400391C0.400391 4.99171 0.680391 4.03971 1.12839 3.19971L1.63239 3.47971Z"
        fill="#007A73"
      />
      <path
        opacity="0.5"
        d="M0.960391 6C0.960391 6.896 1.18439 7.792 1.63239 8.52L1.18439 8.856C0.680391 8.016 0.400391 7.008 0.400391 6H0.960391Z"
        fill="#007A73"
      />
      <path
        opacity="0.6"
        d="M3.20057 10.872C2.36057 10.368 1.68857 9.69602 1.18457 8.85602L1.63257 8.52002C2.08057 9.30402 2.69657 9.92002 3.48057 10.368L3.20057 10.872Z"
        fill="#007A73"
      />
      <path
        opacity="0.7"
        d="M6.0002 11.5997C4.9922 11.5997 4.0402 11.3197 3.2002 10.8717L3.4802 10.3677C4.2082 10.8157 5.1042 11.0397 6.0002 11.0397V11.5997Z"
        fill="#007A73"
      />
      <path
        opacity="0.9"
        d="M8.52051 10.368C9.30451 9.92002 9.92051 9.30402 10.3685 8.52002L10.8725 8.80002C10.3685 9.64002 9.69651 10.312 8.85651 10.816L8.52051 10.368Z"
        fill="#007A73"
      />
      <path
        opacity="0.8"
        d="M6 11.0397C6.896 11.0397 7.792 10.8157 8.52 10.3677L8.856 10.8157C8.016 11.3197 7.008 11.5997 6 11.5997V11.0397Z"
        fill="#007A73"
      />
      <path
        opacity="0.1"
        d="M8.52 1.6319C7.792 1.1839 6.896 0.959902 6 0.959902V0.399902C7.008 0.399902 7.96 0.679902 8.8 1.1279L8.52 1.6319Z"
        fill="#007A73"
      />
      <path
        d="M11.0402 6.28C11.0402 6.112 11.2082 6 11.3202 6C11.4882 6 11.6002 6.168 11.6002 6.28C11.5442 7.176 11.2642 8.016 10.8722 8.8L10.3682 8.52C10.7602 7.848 10.9842 7.064 11.0402 6.28Z"
        fill="#007A73"
      />
      <path
        opacity="0.05"
        d="M10.7045 2.91993C10.8165 3.03193 10.7605 3.19993 10.6485 3.31193C10.5365 3.42393 10.3685 3.36793 10.2565 3.25593C9.8085 2.58393 9.19251 2.02346 8.52051 1.63146L8.80049 1.12793C9.5285 1.57593 10.2005 2.19193 10.7045 2.91993Z"
        fill="#007A73"
      />
    </g>
    <defs>
      <clipPath id="clip0_1142_2342">
        <rect width="11.2" height="11.2" fill="white" transform="translate(0.400391 0.399902)" />
      </clipPath>
    </defs>
  </svg>
);
